import { combineReducers } from 'redux';
import axios from 'axios';
import _ from 'lodash';
import * as Urls from 'src/constants/EndpointUrls';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import {
  fetchList,
  fetchListSuccess,
  fetchListFailure,
  setExtras
} from 'src/reducers/common/listReducer';
import { setItemExtra } from 'src/reducers/common/itemReducer';
import { serializeHttpGetParams, redirectTo } from 'src/utils/Http';
import { takePaysSearchQueries } from 'src/reducers/searchForm';
import { formValues } from 'redux-form';

export const REDUCER_NAME = 'reportSocialSecurityOffices';
export const setDownloadSocialSecurityOfficeOnlineData = () => setItemExtra(REDUCER_NAME, { socialSecurityOfficeErrors });
export const clearDownloadSocialSecurityOfficeOnlineData = () => setItemExtra(REDUCER_NAME, { socialSecurityOfficeErrors: '' });

export const fetchReportDataSocialSecurityOffices = formValues => async dispatch => {
  try {
    dispatch(fetchList(REDUCER_NAME));
    // const params = { groupedPaymentMonths: formValues.groupedPaymentMonths, companyId: formValues.clientWithCompanies };
    const params = { groupedPaymentMonths: formValues.groupedPaymentMonths, clientOrCompanyId: formValues.offices };
    const fetchUrl = `${Urls.SEARCH_SOCIAL_SECURITY_OFFICE_DATA}?${serializeHttpGetParams(params)}`;
    const response = await axios.get(fetchUrl);
    const employeePays = response.data.payload.employeePays;
    const payload = { data: employeePays, pageCount: 0 };
    const { totalEmployees, totalSocialSecurityContributionAmount, targetPeriod } = response.data.payload;
    dispatch(fetchListSuccess(REDUCER_NAME, payload));
    dispatch(setExtras(REDUCER_NAME, { totalEmployees, totalSocialSecurityContributionAmount, targetPeriod }));
  } catch (exception) {
    dispatch(fetchListFailure(REDUCER_NAME, execption.response.data.errors.messages));
  }
}

export const downloadSocialSecurityOfficeOnline = values => async dispatch => {
  try {
    dispatch(clearDownloadSocialSecurityOfficeOnlineData());
    // const params = { groupedPaymentMonths: values.groupedPaymentMonths, companyId: values.clientWithCompanies };
    const params = { groupedPaymentMonths: values.groupedPaymentMonths, companyId: values.offices };
    const url = `${Urls.DOWNLOAD_SOCIAL_SECURITY_OFFICE_ONLINE}?${serializeHttpGetParams(params)}`;
    await axios.get(url);
    redirectTo(url);

  } catch (exception) {

  }
}

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});